export const rugData = [

    {
        id: 1,
        name: 'Orange area rug by Mistana ',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/59578220/resize-h310-w310%5Ecompr-r85/7122/71225798/Hillsby+Blue/Orange+Area+Rug.jpg'
    },
    {
        id: 2,
        name: 'Keneipp Geometric Turquoise by Wrought studio',
        price: '$380',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/77504037/resize-h310-w310%5Ecompr-r85/9789/97890737/Keneipp+Geometric+Turquoise/Brown+Area+Rug.jpg'
    },
    {
        id: 3,
        name: 'Gray Area Rug ',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/59140634/resize-h310-w310%5Ecompr-r85/1214/121443396/Charlotte+Handmade+Shag+Gray+Area+Rug.jpg'
    },
    {
        id: 4,
        name: 'Omie Abstract Turquoise Area Rug by Mercer41',
        price: '$299.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/82928779/resize-h310-w310%5Ecompr-r85/8525/85255328/Omie+Abstract+Turquoise+Area+Rug.jpg'
    },
    {
        id: 5,
        name: 'Lilah PowerLoom Tauoe Rug by Andover Mills',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/07639500/resize-h310-w310%5Ecompr-r85/1242/124201564/Lilah+Power+Loom+Taupe+Rug.jpg'
    },
    {
        id: 6,
        name: 'Warlic iVORY RUG ',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/87225794/resize-h310-w310%5Ecompr-r85/8727/87272917/Warlick+Southwestern+Ivory+Area+Rug.jpg'
    },
    {
        id: 7,
        name: 'Toomsboro area rug by zipcode design',
        price: '$619.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/00197942/resize-h310-w310%5Ecompr-r85/5647/56472762/Toomsboro+Geometric+Burgundy+Area+Rug.jpg'
    },
    {
        id: 8,
        name: 'Nadell Power Loom Brown/Red ',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/86805101/resize-h310-w310%5Ecompr-r85/4713/47137169/Nadell+Power+Loom+Brown/Red+Rug.jpg'
    },
    {
        id: 9,
        name: 'Nadell Floral Area Rug',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/03999031/resize-h310-w310%5Ecompr-r85/5805/58055036/Nadell+Floral+Beige/Brown/Burgundy+Red+Area+Rug.jpg'
    },
    {
        id: 10,
        name: 'cherin modern area rug',
        price: '$200',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/20696890/resize-h310-w310%5Ecompr-r85/5691/56916640/Singletary+Wool+Red/Beige+Area+Rug.jpg'
    },
    {
        id: 11,
        name: 'Damask cream area rug',
        price: '$600',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/04836592/resize-h310-w310%5Ecompr-r85/7122/71225769/Katie+Damask+Cream/Light+Gray+Area+Rug.jpg'
    },
    {
        id: 12,
        name: 'indira abstarct grey/orange area rug',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/63546164/resize-h310-w310%5Ecompr-r85/4791/47918756/Indira+Abstract+Gray/Orange+Area+Rug.jpg'
    },
    {
        id: 13,
        name: 'stevensville area rug',
        price: '$190',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/87005296/resize-h310-w310%5Ecompr-r85/9499/94992941/Stevensville+Abstract+Blue+Area+Rug.jpg'
    },
    {
        id: 14,
        name: 'Nakagawa Wicker patio bar stool',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/06533459/resize-h310-w310%5Ecompr-r85/9031/90312218/Nakagawa+Wicker+28.75%2522+Patio+Bar+Stool+%2528Set+of+4%2529.jpg'
    },
    {
        id: 15,
        name: 'elborough geometric rug',
        price: '$350',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/56699523/resize-h310-w310%5Ecompr-r85/7033/70333194/Elborough+Geometric+Yellow+Rug.jpg'
    },
    {
        id: 16,
        name: 'wyona distressed aqua area rug',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/77034332/resize-h310-w310%5Ecompr-r85/7081/70815215/Wyona+Distressed+Abstract+Navy/Aqua+Area+Rug.jpg'
    },
    {
        id: 17,
        name: 'monterey geometric area rug',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/85779277/resize-h310-w310%5Ecompr-r85/1172/117262380/Monterey+Geometric+Navy+Blue/Gold/Blue+Indoor+/+Outdoor+Area+Rug.jpg'
    },
    {
        id: 18,
        name: 'Farrley Floral By Beachcrest Home',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/69966285/resize-h310-w310%5Ecompr-r85/4234/42347219/Farley+Floral+Gold/Green/Blue+Indoor+/+Outdoor+Area+Rug.jpg'
    }

]